<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/craft/basic/process/route/pageProductCategory" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item class="noborder" :label="$t('gongyiluxianbianma')">
						<el-input disabled v-model="$attrs.craft.code"></el-input>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('gongyiluxianmingcheng')">
						<el-input disabled v-model="$attrs.craft.name"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/craft/basic/process/route/deleteProductCategory')">{{$t('shanchu')}}</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('chanpinfenlei')" required>
						<el-select filterable :clearable="true" v-model="yt.editObj.value">
							<el-option v-for="(item, index) in productCategory" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/craft/basic/process/route/createProductCategory',beforeAdd)"
						type="primary" :loading="yt.editObj.loading">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	
	export default {
		name: 'web_base_craft_product_category',
		
		data() {
			return {
				productCategory:[],
				columns: [{
					label: 'chanpinfenlei',
					prop: 'label',
					width: 130
				}, {
					label: 'chuangjianren',
					prop: 'createByObject.nickname'
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					// format: "YYYY-MM-DD"
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 130,
					fixed: 'right'
				}]
			};
		},

		created() {
			setTimeout(() => {
				this.getProduct();
				this.yt.conditions = {
					processRouteId: this.$attrs.craft.id,
				}
				this.yt.get(1)
			}, 300)
		},
		methods: {
		// 请求查询客户数据字典中的维修方法项
		async getProduct() {
			let response = await this.http.get('/web/config/customer/dictionary/item/getDictionaryByTypeCode', {
				params: {
					code: "GYLXCPFL",
				}
			})
			this.productCategory = response.data
		},
		beforeAdd(params, url) {
			params.processRouteId = this.$attrs.craft.id
			return params
		}
		},
	};
</script>
